export default "__VITE_PUBLIC_ASSET__bd6d43a0__"